module.exports = __webpack_public_path__ + "img/rengongzhineng.0f0e3c11.jpg";